const loginFetch = (path, options) => fetch(`${window.appConfig.PR_BRANCH_OVERRIDE_AUTH_DOMAIN || ''}${path}`, Object.assign(
  {
    credentials: window.appConfig.PR_BRANCH_OVERRIDE_AUTH_CREDENTIALS || 'same-origin',
  },
  options)
);

export default loginFetch;
